// extracted by mini-css-extract-plugin
module.exports = {"desktopFx":"styles_desktopFx__1rNPJ"};